import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { viewTypes } from '@/common/components/FilterViews/constants'
import AppContext from '@/common/context/app.context'
import useNavigateToFilterView from '@/common/hooks/useNavigateToFilterView/useNavigateToFilterView'
import metricsServices from '@/metrics/services/services'
import { outboundDefaultViews, outboundViewIds } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/constants'
import {
  defaultViews as transactionsDefaultViews,
  viewIds as transactionsViewIds,
} from '@/returns/pages/TransactionsPage/constants'
import routes from '@/Router/routes.constants'

const exceptionsView = outboundDefaultViews.find(view => view.id === outboundViewIds.exceptions)
const alertsView = transactionsDefaultViews.find(view => view.id === transactionsViewIds.alerts)

const useAlerts = ({ returnPortalId, isUnifiedDashboard }) => {
  const { updateContext } = useContext(AppContext)

  const { data, loading } = useFetch(metricsServices.getAlerts, {
    doInitialRequest: true,
    params: { returnPortalId },
  })

  const shipmentAlertsCount = data?.shipment_alerts_count || 0
  const transactionAlertsCount = data?.transaction_alerts_count || 0

  const { handleGoView: goToShipmentsView } = useNavigateToFilterView({
    viewType: viewTypes.shipmentsOutbound,
    defaultViews: outboundDefaultViews,
    updateContext,
    returnPortalId,
    route: routes.parcelsPage.outbound,
    filtersKey: 'parcelsOutboundFilters',
  })

  const { handleGoView: goToTransactionsView } = useNavigateToFilterView({
    viewType: viewTypes.transactions,
    defaultViews: transactionsDefaultViews,
    updateContext,
    returnPortalId,
    route: isUnifiedDashboard ? routes.merchantTransactionsPage : routes.transactionsPage,
  })

  const handleShipmentAlertClick = () => {
    goToShipmentsView(exceptionsView)
  }

  const handleTransactionAlertClick = () => {
    goToTransactionsView(alertsView)
  }

  return {
    shipmentAlertsCount,
    transactionAlertsCount,
    loading,
    handleShipmentAlertClick,
    handleTransactionAlertClick,
  }
}

export default useAlerts
